/** Texto aparado, ou `null` quando fica vazio (campo opcional no corpo da API). */
export const textoOuNulo = (valor: string) => valor.trim() || null
